// home page product Tab 
$(document).ready(function () {
    const $group = $(".product-tab-group"); // wrapper of tab contents
    $(".product-tab:first").addClass("active");
    $(".product-tab-content").hide();
    $(".product-tab-content:first").show().addClass("slide-up");
    $group.height($(".product-tab-content:first").outerHeight());
    $(".product-tab").click(function () {
        var value = $(this).attr("data-filter");
        // remove active from all and add to clicked
        $(".product-tab").removeClass("active");
        $(this).addClass("active");
        // find current visible content
        var current = $(".product-tab-content:visible");
        // find target content
        var target = $("." + value);
        if (value === "all") {
            target = $(".product-tab-content");
        }
        if (!target.is(":visible")) {
          // hide current (slide down)
          current.removeClass("slide-up").addClass("slide-down").one("animationend", function () {
            $(this).hide();
          });
          // show target (slide up)
          target.show().removeClass("slide-down").addClass("slide-up");
          // animate wrapper height to match target
          $group.animate({ height: target.outerHeight() }, 500);
        }
    });
    // Adjust height on window resize
    $(window).on("resize", function () {
      let $visible = $(".product-tab-content:visible");
      if ($visible.length) {
        $group.height($visible.outerHeight());
      }
    });

    const $productDetailGroup = $(".product-detail-group");

    // function: find max content height and set to parent
    function setMaxContentHeight() {
      let maxHeight = 0;
      $(".product-detail-content").each(function () {
        maxHeight = Math.max(maxHeight, $(this).outerHeight());
      });
      $productDetailGroup.height(maxHeight);
    }

    $(".product-tab-link:first").addClass("active");
    $(".product-detail-content").hide();
    $(".product-detail-content:first").show().addClass("slide-up");

    // set max height initially
    setMaxContentHeight();

    $(".product-tab-link").click(function () {
      var value = $(this).attr("data-filter");
      $(".product-tab-link").removeClass("active");
      $(this).addClass("active");

      var current = $(".product-detail-content:visible");
      var target = $("." + value);

      if (value === "all") {
        target = $(".product-detail-content");
      }

      if (!target.is(":visible")) {
        current
          .removeClass("slide-up")
          .addClass("slide-down")
          .one("animationend", function () {
            $(this).hide();
          });

        target.show().removeClass("slide-down").addClass("slide-up");
      }
    });

    // window resize pe bhi max height reset
    $(window).on("resize", function () {
      setMaxContentHeight();
    });

});

// cart page left right section
const searchInput = document.querySelector('.cart__footer-wrapper'); // section class who cut
const headerWrapper = document.querySelector('.cart-left-content'); // section class who after paste
if (searchInput && headerWrapper) {
  headerWrapper.insertAdjacentElement('afterend', searchInput);
}

// product-popup-small JS =================
document.addEventListener("DOMContentLoaded", function () {
  const downSection = document.querySelector('.shopify-section');
  const mainSection = document.querySelector('.main-product-section');
  if (!downSection) return;
  const sectionTop = downSection.offsetTop;
  const halfSection = downSection.offsetHeight / 2;
  const triggerPoint = sectionTop + halfSection;

  window.addEventListener('scroll', function () {
    const scrollY = window.scrollY;
    let mainVisible = false;
    if (mainSection) {
      const rect = mainSection.getBoundingClientRect();
      mainVisible = rect.top < window.innerHeight && rect.bottom > 0;
    }

    if (mainVisible) {
      document.body.classList.remove('scrolled-past-feature-product');
    } else if (scrollY >= triggerPoint) {
      document.body.classList.add('scrolled-past-feature-product');
    } else {
      document.body.classList.remove('scrolled-past-feature-product');
    }
  });
});

// EMI popup JS =============
document.addEventListener('DOMContentLoaded', function () {
  const emiLinks = document.querySelectorAll('.emi-check-link'); // all trigger buttons
  const emiPopup = document.getElementById('emi-popup'); // single popup
  const closeBtn = emiPopup.querySelector('.emi-popup-close'); // close inside popup

  if (emiLinks.length && emiPopup && closeBtn) {
    // Open popup on any link click
    emiLinks.forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        emiPopup.style.display = 'flex';
        document.body.style.overflow = 'hidden'; // prevent scroll
        setTimeout(() => emiPopup.classList.add('show'), 10);
      });
    });

    // Close popup function
    function closePopup() {
      emiPopup.classList.remove('show');
      document.body.style.overflow = '';
      setTimeout(() => (emiPopup.style.display = 'none'), 300);
    }

    // Close via button
    closeBtn.addEventListener('click', closePopup);

    // Close on outside click
    emiPopup.addEventListener('click', function (e) {
      if (e.target === emiPopup) {
        closePopup();
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const emiLinks1 = document.querySelectorAll('.drawer__header .emi-check-link'); // all trigger buttons
  const emiLinks2 = document.querySelectorAll('.drawer__header .emi-check-link-cart'); // all trigger buttons
  const emiPopup1 = document.getElementById('emi-popup-cart'); // single popup
  const closeBtn1 = emiPopup1.querySelector('#emi-popup-cart .emi-popup-close'); // close inside popup

  if (emiLinks1.length && emiPopup1 && closeBtn1) {
    // Open popup on any link click
    emiLinks1.forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        emiPopup1.style.display = 'flex';
        document.body.style.overflow = 'hidden'; // prevent scroll
        setTimeout(() => emiPopup1.classList.add('show'), 10);
      });
    });

    // Close popup function
    function closePopup() {
      emiPopup1.classList.remove('show');
      document.body.style.overflow = '';
      setTimeout(() => (emiPopup1.style.display = 'none'), 300);
    }

    // Close via button
    closeBtn1.addEventListener('click', closePopup);

    // Close on outside click
    emiPopup1.addEventListener('click', function (e) {
      if (e.target === emiPopup1) {
        closePopup();
      }
    });
  }
  if (emiLinks2.length && emiPopup1 && closeBtn1) {
    // Open popup on any link click
    emiLinks2.forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        emiPopup1.style.display = 'flex';
        document.body.style.overflow = 'hidden'; // prevent scroll
        setTimeout(() => emiPopup1.classList.add('show'), 10);
      });
    });

    // Close popup function
    function closePopup() {
      emiPopup1.classList.remove('show');
      document.body.style.overflow = '';
      setTimeout(() => (emiPopup1.style.display = 'none'), 300);
    }

    // Close via button
    closeBtn1.addEventListener('click', closePopup);

    // Close on outside click
    emiPopup1.addEventListener('click', function (e) {
      if (e.target === emiPopup1) {
        closePopup();
      }
    });
  }
});

// Theme AOS JS ===============
document.addEventListener("DOMContentLoaded", function() {
  AOS.init({
    duration: 1000,  
    // once: true,   
    offset: 100,  
  });
});


// mobile header JS ===============
const cartDrawer = document.querySelector('cart-drawer.drawer');
const searchToggle = document.querySelector('.header__icon--search'); // adjust selector if needed
const icnAction = document.querySelector('.header__icon--cart');
document.addEventListener("DOMContentLoaded", function () {
  // header-navigation append
  const headerNav = document.querySelector(".header-navigation");
  const burgerMenu = document.querySelector(".burger-menu-drawer");
  const userAction = document.querySelector(".header-right-main .user-action");
  const headerRightMain = document.querySelector(".header-right-main");
  const menuToggle = document.querySelector(".menu-toggle");
  const burgerMenuClose = document.querySelector(".burger-menu-close");

  function moveNav() {
    if (window.innerWidth <= 1023) {
      if (!burgerMenu.contains(headerNav)) {
        burgerMenu.appendChild(headerNav);
      }
    } else {
      if (!headerRightMain.contains(headerNav)) {
        headerRightMain.insertBefore(headerNav, userAction); 
      }
    }
  }
  moveNav();
  window.addEventListener("resize", moveNav);


   // burger-menu-drawer

  // Toggle menu open/close
  if (menuToggle && burgerMenu) {
    menuToggle.addEventListener("click", function () {
      burgerMenu.classList.add("active");
      menuToggle.classList.add("menu-toggle-active");
      document.body.classList.add("overflow-hidden");
      cartDrawer.classList.remove('animate', 'active');
      icnAction.classList.remove('active');
    });
  }

  // Close when clicking close button
  if (burgerMenuClose) {
    burgerMenuClose.addEventListener("click", function () {
      burgerMenu.classList.remove("active");
      menuToggle.classList.remove("menu-toggle-active");
      document.body.classList.remove("overflow-hidden");
    });
  }

  // Close when clicking outside
  document.addEventListener("click", function (e) {
    if (
      burgerMenu.classList.contains("active") &&
      !burgerMenu.contains(e.target) &&
      !menuToggle.contains(e.target)
    ) {
      burgerMenu.classList.remove("active");
      menuToggle.classList.remove("menu-toggle-active");
      document.body.classList.remove("overflow-hidden");
    }
  });

  // header menu js
  const menuItems = document.querySelectorAll(".li-header");

  function enableMobileMenu() {
    if (window.innerWidth <= 1023) {
      menuItems.forEach(item => {
        const arrow = item.querySelector(".header-navlink-arrow");
        const submenu = item.querySelector(".submenu");

        if (arrow && submenu && !arrow.dataset.listenerAdded) {
          arrow.addEventListener("click", function (e) {
            e.preventDefault();
            menuItems.forEach(i => {
              if (i !== item) {
                i.classList.remove("open");
                let otherSub = i.querySelector(".submenu");
                if (otherSub) {
                  otherSub.style.height = null;
                }
              }
            });
            item.classList.toggle("open");

            if (item.classList.contains("open")) {
              submenu.style.height = submenu.scrollHeight + "px";
            } else {
              submenu.style.height = null;
            }
          });
          arrow.dataset.listenerAdded = "true";
        }
      });
    }
  }
  enableMobileMenu();
  window.addEventListener("resize", enableMobileMenu);
});

searchToggle.addEventListener('click', () => {
  if (cartDrawer && cartDrawer.classList.contains('active')) {
    cartDrawer.classList.remove('animate', 'active');
    icnAction.classList.remove('active');
  }
});

document.addEventListener('click', function(event) {
    if (event.target.closest('.password__wrapper a.forgot_pass')) {
      document.querySelector('body').classList.add('reset-show');
    }
});
document.addEventListener('click', function(event) {
    if (event.target.closest('.login__wrapper .login_btn_wraper a')) {
      document.querySelector('body').classList.remove('reset-show');
    }
});

// // gosewell-product-info inset before jquery  
// $( "#main-product-section .product__info-container .gosewell-product-info" ).insertBefore( "#main-product-section .product-cart-form .product-form__buttons" );

// document.addEventListener("DOMContentLoaded", function () {
//   // Search for <variant-selects class="variant-selects"> inside #main-product-section
//   const variantElement = document.querySelector("#main-product-section variant-selects.variant-selects");

//   // If element is not found, add class to body
//   if (!variantElement) {
//     document.body.classList.add("no-variant-selects");
//   }
// });


// document.addEventListener('DOMContentLoaded', () => {
//   const options = document.querySelector('.gose-well-product-options');
//   const info = document.querySelector('.gosewell-product-info');
  
//   if (options && info && options.querySelectorAll('div').length >= 0) {
//     info.classList.add('has-options');
//   }
// });